<template>
	<div class="bar flex">
		<router-link
			:to="{ name: value.linkName }"
			v-for="(value, key) in src"
			:class="{ 'active': value.linkLabel === $root.routeTitle, 'green': value.isGreen }"
			v-if="value"
		>
			<div class="img-container">
				<i :class="value.icon" />
				
			</div>
			<div
				class="title"
				v-html="value.linkTitle" 
			/>
		</router-link>
	</div>
</template>

<script>
export default {
	data () {
		return {
			
		}
	},

	computed: {
		isUserSubscribed () {
			return this.$root.$data.user && this.$root.$data.user.isSubscribed()
		},

		src () {
			let obj =  {
				0: {
					linkName: 'home',
					icon: 'fas fa-home',
					linkTitle: 'Home',
					linkLabel: 'Home'
				},
				1: {
					linkName: 'flow-subscribed',
					icon: 'fas fa-utensils',
					linkTitle: 'Spesa',
					linkLabel: 'Componi la tua box'
				},
				2: {
					linkName: 'cookbook',
					icon: 'fas fa-book',
					linkTitle: 'Ricettario',
					linkLabel: 'Ricettario'
				},
			};

			if(this.$root.$data.user && !this.$root.$data.user.email.includes('guest.quomi.it')) {
				obj[3] = {
					linkName: 'profile',
					icon: 'fas fa-user',
					linkTitle: 'Profilo',
					linkLabel: 'Profilo'
				}
			}

			return obj;
		}
	}
}
</script>

<style scoped>
.bar {
	position: fixed;
	bottom: 0;
	height: 45px;
	width: 100%;
	background-color: white;
	color: black;
	z-index: 3;
	font-size: 10px;
}

.flex > a {
	flex-basis: 25%;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	line-height: 1;
	padding: 2px 6px;
	overflow: hidden;
	border-top: 1px solid #ededed;
	color: #575A5C;
}

.flex > a:not(:last-child) {
	border-right: 1px solid #ededed;
}

.flex > a.active {
	color: var(--quomi-primary);
}

.flex > a.green {
	color: white;
	background-color: var(--quomi-orange);
}
.flex > a.green.active {
	color: var(--quomi-orange);
	background-color: white;
}

.title {
	white-space: nowrap;
}

.img-container {
	padding-bottom: 3px;
	height: 20px;
	overflow: hidden;
	font-size: 18px;
}

</style>
